import { Box, Modal } from "@mui/material";
import "./TermsConditions.css";
import CloseIcon from '@mui/icons-material/Close';



const TermsConditions = ({
  isTermsAndConditionsModalOpen,
  setIsTermsAndConditionsModalOpen,
}: any) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // Height: "80%",
    width: "75%",
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 4,
  };
  return (
    <div>
      <Modal
        open={isTermsAndConditionsModalOpen}
        onClose={() => setIsTermsAndConditionsModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <div>
              <div className="terms-condition-container">
                <div className="header-session">
                  <h4 className="header">Spark SaaS Terms of Use</h4>
                  <CloseIcon  onClick={()=>setIsTermsAndConditionsModalOpen(false)} className="close-icon" style={{cursor:'pointer',height:'20px',width:'20px'}}/>
                </div>

                <div className="modal-content scroll">
                  <div>
                    <div>
                      <p>
                        THIS AGREEMENT TAKES EFFECT WHEN YOU CLICK THE "I
                        ACCEPT" BUTTON BELOW OR BY ACCESSING OR USING THE SAAS
                        SERVICES ("EFFECTIVE DATE"). BY CLICKING ON THE "I
                        ACCEPT" BUTTON BELOW OR BY ACCESSING OR USING THE SAAS
                        SERVICES YOU (A) ACKNOWLEDGE THAT YOU HAVE READ AND
                        UNDERSTAND THIS AGREEMENT; (B) REPRESENT AND WARRANT
                        THAT YOU HAVE THE RIGHT, POWER, AND AUTHORITY TO ENTER
                        INTO THIS AGREEMENT AND, IF ENTERING INTO THIS AGREEMENT
                        FOR AN ORGANIZATION, THAT YOU HAVE THE LEGAL AUTHORITY
                        TO BIND THAT ORGANIZATION; AND (C) ACCEPT THIS AGREEMENT
                        AND AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS. IF
                        YOU DO NOT ACCEPT THESE TERMS, YOU MAY NOT ACCESS OR USE
                        THE SAAS SERVICES.{" "}
                      </p>
                    </div>

                    <div>
                      <h6>1.Acceptance</h6>

                      <p>
                        <strong>1.1</strong> These Terms and Conditions, and any
                        other terms and policies referred to in these Terms and
                        Conditions, form the agreement between Verastel, Inc.,
                        (referred to as “SaaS Provider”, “we” or “us”) and the
                        user (referred to as “Customer” or “you”), collectively
                        referred to as the Parties or each a Party,
                        (“Agreement”).
                      </p>

                      <p>
                        <strong>1.2</strong> The SaaS Provider owns, or holds
                        the relevant rights to, the Spark Software and will
                        license the use of the Software as a service to the
                        Customer.
                      </p>

                      <p>
                        <strong>1.3</strong> The Customer wishes to license the
                        SaaS Services available at{" "}
                        <a href="https://spark.verastel.ai">
                          https://spark.verastel.ai
                        </a>{" "}
                        (“Site”) from the SaaS Provider.
                      </p>

                      <p>
                        <strong>1.4</strong> This Agreement sets out the terms
                        upon which the SaaS Provider has agreed to grant a
                        license to the Customer to use the SaaS Services. This
                        Agreement is binding on any use of the Services and
                        applies to the Customer from the time that the SaaS
                        Provider provides the Customer with an account
                        (“Customer’s account”) to access and use the Services
                        (“Effective Date”).
                      </p>

                      <p>
                        <strong>1.5</strong> If the Services are provided for
                        evaluation by the Customer (“Evaluation Services”), the
                        terms herein applicable to Services also apply to access
                        and use of such Evaluation Services, except for the
                        following alternate or additional terms: (i) the
                        duration of the evaluation is as mutually agreed upon by
                        the Customer and SaaS Provider; (ii) either the Customer
                        or SaaS Provider can terminate the evaluation at any
                        time upon written notice to the other Party; and (iii)
                        the Evaluation Services are provided “as-is” without
                        warranty of any kind, and SaaS Provider disclaims all
                        warranties, support obligations, and other liabilities
                        and obligations for the Evaluation Services.
                      </p>
                    </div>

                    <div>
                      <h6>2. Definitions and Interpretation</h6>

                      <h6>2.1 Definitions</h6>

                      <p>
                        <strong>a. “Additional Costs”</strong> means any
                        additional costs, expenses, damages or losses suffered
                        or incurred by the SaaS Provider.
                      </p>

                      <p>
                        <strong>b. “Business Day”</strong> means a day on which
                        banks are open for general banking business in the
                        United States, excluding Saturdays, Sundays, and public
                        holidays.
                      </p>

                      <p>
                        <strong>c. “Business Hours”</strong> means 9 am to 5 pm
                        on a Business Day.
                      </p>

                      <p>
                        <strong>d. “Claim”</strong> means any actual,
                        contingent, present, or future claim, demand, action,
                        suit, or proceeding for any Liability, restitution,
                        equitable compensation, account, injunctive relief,
                        specific performance or any other remedy of whatever
                        nature and however arising, whether direct or indirect,
                        and whether in contract, tort (including but not limited
                        to negligence) or otherwise.
                      </p>

                      <p>
                        <strong>e. “Confidential Information”</strong> includes
                        information or documentation which:
                      </p>

                      <ul>
                        <li>
                          i. is disclosed to the recipient in connection with
                          this Agreement (whether before or after the Effective
                          Date);
                        </li>

                        <li>
                          ii. is prepared or produced under or in connection
                          with this Agreement (whether before or after the
                          Effective Date); or
                        </li>

                        <li>iii. relates to:</li>

                        <ul>
                          <li>
                            A. the business, assets or affairs of a Party;
                          </li>

                          <li>
                            B. the subject matter of, the terms of and/or any
                            transactions contemplated by this Agreement, whether
                            or not such information or documentation is reduced
                            to a tangible form or marked in writing as
                            “confidential”, and whether it is disclosed to the
                            recipient or received, acquired, overheard or learnt
                            by the recipient in any way whatsoever.
                          </li>
                        </ul>
                      </ul>

                      <p>
                        <strong>f. “Contract Year”</strong> means a 12 month
                        period commencing on: (i) the Effective Date; and (ii)
                        each subsequent anniversary of the Effective Date, of
                        this Agreement during the Term.
                      </p>

                      <p>
                        <strong>g. “Customer Environment”</strong> means the
                        computing environment of the Customer including all
                        hardware, software, information technology and
                        telecommunications services and Systems.
                      </p>

                      <p>
                        <strong>h. “Data”</strong> means all of the information,
                        documents and other data provided by the Customer or
                        their Personnel to the SaaS Provider, any content
                        uploaded by the Customer or Personnel to the SaaS
                        Provider’s System, or otherwise accessed by the SaaS
                        Provider in providing the Services. i. The data of the
                        customer entity and their personnel administrator,
                        advanced users and basic users, and the asset related
                        data shall be stored for a duration of 90 days or higher
                        depending on the features invoked that necessitate a
                        longer time window.
                      </p>

                      <p>
                        <strong>j. Upon deletion</strong> a business user
                        account of the business entity the business ceases to be
                        a user of the SPARK tool there by deleting all the data
                        pertaining to that business be it personal and/or asset
                        information will be deleted or forgotten by the SaaS
                        platform with immediate effect. Upon deletion user
                        account within an active business account the data
                        pertaining to the use will be accessible by the
                        administrator of the business account.
                      </p>

                      <p>
                        <strong>
                          k. For on premise or private cloud deployment
                        </strong>{" "}
                        Product licenses shall be in accordance with the terms
                        of the applicable licensing model as set forth in the
                        Documentation and the Ordering Document, which may
                        include limitations on Scan Targets, License Term, the
                        number of users, seats, licenses and/or types of modules
                        licensed. Product licenses shall commence upon Delivery
                        and shall be either perpetual or subscription in nature.
                        If Customer exceeds the license restrictions, Customer
                        must purchase an upgraded license to allow for all
                        actual or additional usage.
                      </p>

                      <p>
                        <strong>
                          l. For a SaaS model on Verastel cloud, “Fee”
                        </strong>{" "}
                        means the fee will be set out on the Site for the
                        Customer account applicable when launched in SaaS mode.
                      </p>

                      <p>
                        <strong>
                          m. For the enterprise or bespoke deployment
                        </strong>{" "}
                        after completion of free evaluation period invoices will
                        be generated on a case-by-case basis depending on the
                        scope of the bespoke solution.
                      </p>

                      <p>
                        <strong>n. “Force Majeure”</strong> means any event or
                        circumstances beyond the reasonable control of a Party
                        including any fire, lightning strike, flood, earthquake,
                        natural disaster, sabotage, nuclear contamination,
                        terrorism, war or civil riot that occurs to the extent
                        that it:
                      </p>

                      <ul>
                        <li>
                          i. would be unreasonable to expect the affected Party
                          to have planned for, avoided or minimized the impact
                          of such circumstance by appropriate risk management,
                          disaster recovery or business resumption plan; and
                        </li>

                        <li>
                          ii. results in a Party being unable to perform an
                          obligation under this Agreement on time.
                        </li>
                      </ul>

                      <p>
                        <strong>o. “Initial Term”</strong> means the initial
                        term set out in the Customer account.
                      </p>

                      <p>
                        <strong>p. “Insolvency Event”</strong> means the
                        occurrence of any one or more of the following events in
                        relation to a Party:
                      </p>

                      <ol type="i">
                        <li>
                          the Party is or states that it is insolvent or is
                          deemed or presumed to be insolvent under any
                          applicable laws;
                        </li>

                        <li>
                          an application or order is made for the winding up,
                          bankruptcy or dissolution of the Party or a resolution
                          is passed or any steps are taken to pass a resolution
                          for its winding up or dissolution;
                        </li>

                        <li>
                          an administrator, provisional liquidator, liquidator
                          or person having a similar or analogous function under
                          the laws of any relevant jurisdiction is appointed in
                          respect of the Party or any action is taken to appoint
                          any such person and the action is not stayed,
                          withdrawn or dismissed within 10 Business Days;
                        </li>

                        <li>
                          a controller is appointed in respect of any of the
                          Party’s property;
                        </li>

                        <li>
                          a distress, attachment or execution is levied or
                          becomes enforceable against the Party or any of its
                          property;
                        </li>

                        <li>
                          the Party enters into or takes action to enter into an
                          arrangement, composition or compromise with, or
                          assignment for the benefit of, all or any class of its
                          creditors or members or a moratorium involving any of
                          them;
                        </li>

                        <li>
                          a receiver or manager (or both) or trustee in
                          bankruptcy is appointed in respect of the Party or its
                          property;
                        </li>

                        <li>
                          a petition for the making of a sequestration order
                          against the estate of the Party is presented and the
                          petition is not stayed, withdrawn or dismissed within
                          10 Business Days or the Party presents a petition
                          against itself; or
                        </li>

                        <li>
                          anything analogous to or of a similar effect to
                          anything described above under the law of any relevant
                          jurisdiction occurs in respect of the Party.
                        </li>
                      </ol>

                      <p>
                        <strong>q. “Intellectual Property Rights”</strong> means
                        all present and future rights to:
                      </p>

                      <ol type="i">
                        <li>copyright;</li>

                        <li>
                          registered or unregistered designs, patents,
                          trademarks;
                        </li>

                        <li>trade, business, company or domain names;</li>

                        <li>know-how, inventions, processes, trade secrets;</li>

                        <li>circuit layouts, databases or source codes; and</li>

                        <li>
                          any similar rights in any part of the world, including
                          any application, or right to apply, for registration
                          of, and any improvements, enhancements or
                          modifications of, the foregoing.
                        </li>
                      </ol>

                      <p>
                        <strong>r. “Liability”</strong> means any expense,
                        charge, cost, liability, loss, damage, claim, demand or
                        proceeding (whether under statute, contract, equity,
                        tort - including negligence - indemnity or otherwise),
                        howsoever arising, whether direct or indirect and/or
                        whether present, unascertained, future or contingent.
                      </p>

                      <p>
                        <strong>s. “Party”</strong> means a party to this
                        Agreement from time to time, and{" "}
                        <strong>“Parties”</strong> means all of them.
                      </p>

                      <p>
                        <strong>t. “Payment Method”</strong> is by credit card,
                        Wire Transfers, or Bank Deposit.
                      </p>

                      <p>
                        <strong>u. “Payment Terms”</strong> means 30 days from
                        the date of the invoice.
                      </p>

                      <p>
                        <strong>v. “Personnel”</strong> means in relation to a
                        Party, any employee, contractor, officer, and agent of
                        that Party.
                      </p>

                      <p>
                        <strong>w. “Products”</strong> means hardware or
                        software.
                      </p>

                      <p>
                        <strong>x. “SaaS License”</strong> is defined in Section
                        4.1.
                      </p>

                      <p>
                        <strong>y. “SaaS Services”</strong> means the Verastel’s
                        Spark Software as a service described on the Site.
                      </p>

                      <p>
                        <strong>z. “Service Level”</strong> means any service
                        levels set out on the Site.
                      </p>

                      <p>
                        <strong>aa. “Services”</strong> means the SaaS Services
                        and Support Services, to be provided or licensed by the
                        SaaS Provider to the Customer on the terms and
                        conditions set out in this Agreement.
                      </p>

                      <p>
                        <strong>bb. “Software”</strong> means the software used
                        to provide the Services, and includes any instructions
                        in hard copy or electronic form and any update,
                        modification, or release of any part of that software
                        after this Agreement is entered into by the Parties.
                      </p>

                      <p>
                        <strong>cc. “Support Hours”</strong> means:
                      </p>

                      <ol type="i">
                        <li>
                          the hours the SaaS Provider will provide the Support
                          Services as set out on the Site; or
                        </li>

                        <li>
                          if such hours are not specified, a EST Business Hours.
                        </li>
                      </ol>

                      <p>
                        <strong>dd. “Support Services”</strong> are as set out
                        on the Site.
                      </p>

                      <p>
                        <strong>ee. “System”</strong> means a combination of
                        Products or a combination of Products and services which
                        are integrated and operate together, including a
                        network.
                      </p>

                      <p>
                        <strong>ff. “Term”</strong> means the term of this
                        Agreement as set out in Section 18.
                      </p>

                      <p>
                        <strong>gg. “Variation”</strong> means a change to the
                        SaaS License after the date of this Agreement.
                      </p>

                      <p>
                        <strong>hh. “Variation Fee”</strong> means any variation
                        to the Fee as a consequence of the Variation.
                      </p>

                      <h6>2.2 Interpretation</h6>

                      <p>
                        In this Agreement, unless the context otherwise
                        requires:
                      </p>

                      <p>
                        <strong>a. </strong>the singular includes the plural and
                        vice versa;
                      </p>

                      <p>
                        <strong>b. </strong>headings are for convenience only
                        and do not affect interpretation;
                      </p>

                      <p>
                        <strong>c. </strong>a reference to a Section, paragraph,
                        schedule or annexure is a reference to a Section,
                        paragraph, schedule or annexure, as the case may be, of
                        this Agreement;
                      </p>

                      <p>
                        <strong>d. </strong>if any act which must be done under
                        this Agreement is to be done on a day that is not a
                        Business Day then the act must be done on or by the next
                        Business Day;
                      </p>

                      <p>
                        <strong>e. </strong>a reference to any legislation or
                        law includes subordinate legislation or law and all
                        amendments, consolidations, replacements or
                        re-enactments from time to time;
                      </p>

                      <p>
                        <strong>f. </strong>where a word or phrase is defined,
                        its other grammatical forms have a corresponding
                        meaning;
                      </p>

                      <p>
                        <strong>g. </strong>a reference to a natural person
                        includes a body corporate, partnership, joint venture,
                        association, government or statutory body or authority
                        or other legal entity and vice versa;
                      </p>

                      <p>
                        <strong>h. </strong>includes and similar words mean
                        includes without limitation;
                      </p>

                      <p>
                        <strong>i. </strong>no Section will be interpreted to
                        the disadvantage of a Party merely because that Party
                        drafted the Section or would otherwise benefit from it;
                      </p>

                      <p>
                        <strong>j. </strong>a reference to a Party to a document
                        includes that Party’s executors, administrators,
                        successors, permitted assigns and persons substituted by
                        novation from time to time;
                      </p>

                      <p>
                        <strong>k. </strong>a reference to this Agreement or any
                        other document includes the document, all schedules and
                        all annexures as novated, amended, supplemented, varied
                        or replaced from time to time;
                      </p>

                      <p>
                        <strong>l. </strong>a reference to a covenant,
                        obligation or agreement of two or more persons binds or
                        benefits them jointly and severally;
                      </p>

                      <p>
                        <strong>m. </strong>if a period of time is specified and
                        dates from a given day or the day of an act or event, it
                        is to be calculated exclusive of that day;
                      </p>

                      <p>
                        <strong>n. </strong>a reference to time is to local time
                        in New York; and
                      </p>

                      <p>
                        <strong>o. </strong>a reference to $ or dollars refers
                        to American Dollars from time to time.
                      </p>
                    </div>

                    <div>
                      <h6>3. Services</h6>

                      <p>
                        <strong>3.1</strong> On or from the Effective Date and
                        during the Term, the SaaS Provider agrees to provide the
                        Services in accordance with the terms of this Agreement.
                      </p>

                      <p>
                        <strong>3.2</strong> The Customer agrees the SaaS
                        Provider owns or holds the applicable licenses to all
                        Intellectual Property Rights including but not limited
                        to copyright in the Software and SaaS Services and any
                        documentation provided with the Services by the SaaS
                        Provider to the Customer including any Customer
                        configuration documentation.
                      </p>

                      <p>
                        <strong>3.3</strong> The SaaS Provider reserves the
                        right to change or remove features of the SaaS Services
                        from time to time.
                      </p>

                      <p>
                        <strong>3.4</strong> The Parties agree that the SaaS
                        Provider:
                      </p>

                      <ol type="a">
                        <li>
                          will supply the Services on a non-exclusive basis;
                        </li>

                        <li>
                          does not make any warranty or representation as to the
                          ability of the facilities or services of any
                          third-party suppliers; and
                        </li>

                        <li>
                          is not liable for any failure in, fault with or
                          degradation of the Services if that failure, fault or
                          degradation is attributable to or caused by any
                          failure of the Customer Environment or the facilities
                          or services of any third party.
                        </li>
                      </ol>

                      <p>
                        <strong>3.5</strong> The SaaS Provider reserves the
                        right to refuse any request in relation to the Services
                        that it deems inappropriate, unreasonable or illegal.
                      </p>
                    </div>

                    <div>
                      <h6>4. SaaS Service License</h6>

                      <p>
                        <strong>4.1</strong> In consideration for payment of the
                        Fees, the SaaS Provider grants to the Customer a
                        non-exclusive, non-transferable (except as otherwise
                        permitted under this Agreement), personal, revocable,
                        license to access and use the SaaS Services in
                        accordance with the Service Provider’s intended purpose
                        for the SaaS Services (“SaaS License”).
                      </p>

                      <p>
                        <strong>4.2</strong> The Customer agrees that the SaaS
                        License:
                      </p>

                      <ol type="a">
                        <li>
                          commences from the Effective Date or the day the
                          Customer is granted access to the SaaS Services by the
                          SaaS Provider, whichever occurs first;
                        </li>

                        <li>
                          permits the Customer to use the SaaS Services in
                          accordance with the SaaS Services’ normal operating
                          procedures; and
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>5. License Restrictions</h6>

                      <p>
                        <strong>5.1</strong> The Customer must not access or use
                        the SaaS Services except as permitted by the SaaS
                        License and may not do or authorize the commission of
                        any act that would or might invalidate or be
                        inconsistent with the SaaS Provider’s Intellectual
                        Property Rights in the SaaS Services or Software.
                        Without limiting the foregoing provisions, the Customer
                        agrees and acknowledges that it must not and will not
                        permit any person to:
                      </p>

                      <ol type="a">
                        <li>
                          resell, assign, transfer, distribute or provide others
                          with access to the SaaS Services;
                        </li>

                        <li>
                          “frame”, “mirror” or serve any of the SaaS Services on
                          any web server or other computer server over the
                          Internet or any other network;
                        </li>

                        <li>
                          copy, alter, modify, create derivative works from,
                          reproduce, resell, transfer to a third party, reverse
                          assemble, reverse engineer, reverse compile or enhance
                          the SaaS Services or Software; or
                        </li>

                        <li>
                          alter, remove or tamper with any trademarks, any
                          patent or copyright notices, or any confidentiality
                          legend or notice, or any numbers, or other means of
                          identification used on or in relation to the SaaS
                          Services or Software.
                        </li>
                      </ol>

                      <p>
                        <strong>5.2</strong> The Customer must not use the SaaS
                        Services in any way which is in breach of any statute,
                        regulation, law or legal right of any person within the
                        United States or the jurisdiction in which the Customer
                        or its Personnel are located.
                      </p>
                    </div>

                    <div>
                      <h6>6. Data</h6>

                      <p>
                        <strong>6.1</strong> The Customer grants to the SaaS
                        Provider a limited license to copy, transmit, store and
                        back-up or otherwise access, use or make reference to
                        any Intellectual Property Rights in the Data:
                      </p>

                      <ol type="a">
                        <li>
                          to supply the Services including to enable the
                          Customer, its Personnel to access and use the
                          Services;
                        </li>

                        <li>
                          to do analysis for the purposes of predictive safety
                          analytics and industry guideline production and other
                          uses;
                        </li>

                        <li>for diagnostic purposes;</li>

                        <li>
                          to test, enhance and otherwise modify the Services
                          whether requested by the Customer or not;
                        </li>

                        <li>to develop other Services; and</li>

                        <li>
                          as reasonably required for the performance of the SaaS
                          Provider’s obligations under this Agreement.
                        </li>
                      </ol>

                      <p>
                        <strong>6.2</strong> The Customer represents and
                        warrants that:
                      </p>

                      <ol type="a">
                        <li>
                          any and all Data supplied by the Customer or otherwise
                          accessed by the SaaS Provider through the provision of
                          the Services is the sole and exclusive property of the
                          Customer or the Customer has secured any and all
                          authorizations and rights to use the Data as
                          applicable;
                        </li>

                        <li>
                          its Data does not breach any relevant laws,
                          regulations or codes;
                        </li>

                        <li>
                          its Data does not infringe the Intellectual Property
                          Rights of any third party;
                        </li>

                        <li>
                          it will comply with all applicable laws and
                          regulations in the jurisdiction where the Customer
                          accesses and publishes content using the SaaS
                          Services; and
                        </li>

                        <li>
                          to the extent that the Data contains personal data (if
                          any), it has obtained the necessary consents in order
                          to transfer or permit access to this Data in
                          accordance with applicable privacy and data protection
                          laws.
                        </li>
                      </ol>

                      <p>
                        <strong>6.3</strong> The Customer acknowledges and
                        agrees that:
                      </p>

                      <ol type="a">
                        <li>
                          any collation, conversion and analysis of Data
                          performed as part of the Services whether by the
                          Services or otherwise is likely to be subject to human
                          input and machine errors, omissions, delays and losses
                          including but not limited to any loss of Data. The
                          SaaS Provider is not liable for any such errors,
                          omissions, delays or losses. The Customer acknowledges
                          and agrees it is responsible for adopting reasonable
                          measures to limit the impact of such loss or error;
                        </li>

                        <li>
                          The SaaS Provider may relocate the Data to another
                          jurisdiction.
                        </li>

                        <li>
                          The SaaS Provider is not responsible for any
                          corruption or loss of any Data if such corruption or
                          loss is due to an act or omission by the Customer, its
                          Personnel; and
                        </li>

                        <li>
                          The SaaS Provider is not responsible for the integrity
                          or existence of any Data on the Customer’s
                          Environment, network or any asset controlled by the
                          Customer or its Personnel.
                        </li>
                      </ol>

                      <p>
                        <strong>6.4</strong> The Customer agrees to indemnify
                        and hold the SaaS Provider harmless for the corruption
                        or loss of any Data controlled or stored by the
                        Customer, to the extent the corruption or loss is not
                        caused by the negligent act or omission of the SaaS
                        Provider or its Personnel.
                      </p>
                    </div>

                    <div>
                      <h6>7. Support and Service Levels</h6>

                      <p>
                        <strong>7.1</strong> During the Term, the SaaS Provider
                        will provide the Support Services in accordance with the
                        Service Levels during the Support Hours provided that:
                      </p>

                      <ol type="a">
                        <li>
                          the Customer provides the SaaS Provider with notice
                          for applicable Services in accordance with any
                          applicable system and processes as set out on the
                          Site, as applicable; and
                        </li>

                        <li>
                          where required, the Customer assists with
                          investigating and ascertaining the cause of the fault
                          and provides to the SaaS Provider all necessary
                          information relevant to the fault (including but not
                          limited to what the Customer or their Personnel has
                          done in relation to the fault).
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>8. SaaS Provider Responsibilities and Obligations</h6>

                      <p>
                        The SaaS Provider must maintain commercially reasonable
                        security measures to protect all Confidential
                        Information in its possession or control, or in the
                        possession or control of its Personnel, from
                        unauthorized access, use, copying, or disclosure.
                      </p>
                    </div>

                    <div>
                      <h6>9. Customer Responsibilities and Obligations</h6>

                      <p>
                        <strong>9.1</strong> The Customer will provide all
                        required materials/access as required by the SaaS
                        Provider from time to time for the SaaS Provider to
                        perform the Services.
                      </p>

                      <p>
                        <strong>9.2</strong> The Customer must, at the
                        Customer’s own expense:
                      </p>

                      <ol type="a">
                        <li>
                          provide all reasonable assistance and cooperation to
                          the SaaS Provider in order to enable the SaaS Provider
                          to supply the Services in an efficient and timely
                          manner;
                        </li>

                        <li>
                          use reasonable endeavors to ensure the integrity of
                          the Data;
                        </li>

                        <li>
                          permit the SaaS Provider and its Personnel to have
                          reasonable access to the Customer Environment for the
                          purposes of supplying the Services;
                        </li>

                        <li>
                          ensure that only Customer Personnel will access and
                          use the SaaS Services and such use and access will be
                          in accordance with the terms and conditions of the
                          SaaS License; and
                        </li>

                        <li>
                          make any changes to its Customer Environment that may
                          be required to support the delivery and operation of
                          any Services.
                        </li>
                      </ol>

                      <p>
                        <strong>9.3</strong> The Customer is responsible for its
                        use of the Services and must ensure that no person uses
                        the Services:
                      </p>

                      <ol type="a">
                        <li>
                          to violate any law or infringe any person’s rights
                          including but not limited to Intellectual Property
                          Rights;
                        </li>

                        <li>
                          to transmit, publish or communicate material that is
                          defamatory, offensive, abusive, indecent, menacing or
                          unwanted; or
                        </li>

                        <li>
                          in any way that damages, interferes with or interrupts
                          the supply of the Services.
                        </li>
                      </ol>

                      <p>
                        <strong>9.4</strong> The Customer acknowledges and
                        agrees that:
                      </p>

                      <ol type="i">
                        <li>
                          it is responsible for all users using the Services
                          including its Personnel;
                        </li>

                        <li>
                          its use of the Services will be at its own risk;
                        </li>

                        <li>
                          it is responsible for maintaining the security of its
                          account and password. The SaaS Provider cannot and
                          will not be liable for any loss or damage from the
                          Customer’s failure to comply with this security
                          obligation;
                        </li>

                        <li>
                          the SaaS Provider may alter or update the Customer’s
                          account logins and passwords at any time throughout
                          the Term;
                        </li>

                        <li>
                          the Customer is responsible for all content
                          posted/uploaded and activity that occurs under their
                          account. This includes content posted/uploaded by
                          others who have logins or accounts associated with the
                          Customer’s account;
                        </li>

                        <li>
                          the technical processing and transmission of the
                          Service, including the Customer’s content, may be
                          transferred unencrypted and involve (a) transmissions
                          over various networks; and (b) changes to conform and
                          adapt to technical requirements of connecting networks
                          or assets;
                        </li>

                        <li>
                          if the SaaS Provider wishes to alter the delivery of
                          the SaaS Services which requires a change to the
                          Customer Environment (including reconfigurations or
                          interface customizations the extent necessary to
                          access or use the SaaS Services) the Customer will
                          give any assistance to the SaaS Provider or make any
                          such changes to the Customer Environment, that the
                          SaaS Provider reasonably requires; and
                        </li>

                        <li>
                          the SaaS Provider may pursue any available equitable
                          or other remedy against the Customer as a result of a
                          breach by the Customer of any provision of this
                          Agreement.
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>10. Prohibited Use</h6>

                      <p>
                        <strong>10.1</strong> The Customer acknowledges and
                        agrees that this Agreement incorporates by reference the
                        terms of any acceptable use policy as set out on the
                        SaaS Provider’s website.
                      </p>

                      <p>
                        <strong>10.2</strong> The Customer acknowledges and
                        agrees that it must not:
                      </p>

                      <ol type="a">
                        <li>
                          use the SaaS Services to violate any legal rights of
                          any person or entity in any jurisdiction;
                        </li>

                        <li>
                          use the SaaS Services in relation to crimes such as
                          theft and fraud;
                        </li>

                        <li>
                          use the Services in breach of laws relating to the
                          protection of copyright, trade secrets, patents or
                          other intellectual property and laws relating to spam
                          or privacy;
                        </li>

                        <li>
                          make any unauthorized copy of any copyrighted material
                          owned or licensed by the SaaS Provider;
                        </li>

                        <li>
                          introduce malicious programs into the SaaS Provider
                          System (e.g. viruses, worms, trojan horses, e-mail
                          bombs);
                        </li>

                        <li>
                          reveal the Customer’s account password to others or
                          allow use of the Customer’s account to those who are
                          not the Customer’s Personnel;
                        </li>

                        <li>
                          use the SaaS Services to make fraudulent offers of
                          goods or services;
                        </li>

                        <li>
                          use the SaaS Services to carry out Security Breaches
                          or disruptions of a network. Security Breaches
                          include, but are not limited to, accessing data of
                          which the Customer is not an intended recipient or
                          logging into a server or account that the Customer is
                          not expressly authorized to access or corrupting any
                          data. For the purposes of this paragraph, “security
                          breaches” includes, but is not limited to, network
                          sniffing/monitoring, pinged floods, packet spoofing,
                          denial of service, and forged routing information for
                          malicious purposes;
                        </li>

                        <li>
                          use any program/script/command, or sending messages of
                          any kind, with the intent to interfere with, or
                          disable, any persons’ use of the SaaS Services;
                        </li>

                        <li>
                          send any unsolicited email messages through or to
                          users of the SaaS Services or to send any form of
                          harassment via email, or any other form of messaging,
                          whether through language, frequency, or size of
                          messages; use the SaaS Services in breach of any
                          person’s privacy (such as by way of identity theft or
                          “phishing”) is strictly prohibited; and
                        </li>

                        <li>
                          use the SaaS Services to circumvent user
                          authentication or security of any of the Customer’s
                          hosts, networks or accounts or those of the Customer’s
                          customers or suppliers.
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>11. Communication</h6>

                      <p>
                        Each Party will appoint and maintain at all times a
                        relationship manager who will be responsible for the
                        management of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>12. Payment</h6>

                      <p>
                        <strong>12.1</strong> The Customer must pay the SaaS
                        Provider: (a) the Fee; and (b) any other amount payable
                        to the SaaS Provider under this Agreement, without set
                        off or delay using the Payment Method in accordance with
                        the Payment Terms. All Fees are in USD$, and are payable
                        in advance.
                      </p>

                      <p>
                        <strong>12.2</strong> If the Customer requires the use
                        of a purchase order, the Customer is responsible for
                        providing the applicable purchase order at the time of
                        purchase. The Customer acknowledges and agrees to the
                        extent of any inconsistency between this Agreement and
                        any terms and conditions attached to the Customer’s
                        purchase order, the terms of this Agreement will
                        prevail. The Parties acknowledge and agree that any
                        pre-printed standard terms and conditions attached to or
                        on the back of any purchase order will not apply to this
                        Agreement.
                      </p>

                      <p>
                        <strong>12.3</strong> If there is a Variation, the SaaS
                        Provider will include the Variation Fees due and payable
                        for the Variation performed in invoice(s) subsequent to
                        the performance of any Variation.
                      </p>

                      <p>
                        <strong>12.4</strong> If any payment has not been made
                        in accordance with the Payment Terms, the SaaS Provider
                        may (at its absolute discretion):
                      </p>

                      <ol type="a">
                        <li>
                          immediately cease providing the Services, and recover
                          as a debt due and immediately payable from the
                          Customer its Additional Costs of doing so;
                        </li>

                        <li>
                          engage debt collection services and/or commence legal
                          proceedings in relation to any such amounts; and/or
                        </li>

                        <li>
                          report the Customer to any independent credit data
                          agencies.
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>13. Confidentiality</h6>

                      <p>
                        <strong>13.1</strong> Subject to Section 13.2, each
                        Party must (and must ensure that its Personnel do): keep
                        confidential; and not use or permit any unauthorized use
                        of all Confidential Information. Section 13.1 does not
                        apply where:
                      </p>

                      <ol type="a">
                        <li>
                          the information is in, or comes into, the public
                          domain (other than by a breach of this Section 13 by
                          the relevant Party);
                        </li>

                        <li>
                          the relevant Party has the prior written consent of
                          the Party that disclosed the Confidential Information;
                        </li>

                        <li>the disclosure is required by law;</li>

                        <li>
                          the disclosure is required in order to comply with
                          this Agreement, provided that the Party disclosing the
                          Confidential Information ensures the recipient
                          complies with the terms of this Section 13; and
                        </li>

                        <li>
                          the disclosure is to a professional adviser in order
                          to obtain advice in relation to matters arising in
                          connection with this Agreement and provided that the
                          Party disclosing the Confidential Information ensures
                          the adviser complies with the terms of this Section.
                        </li>
                      </ol>

                      <p>
                        <strong>13.2</strong> Each Party acknowledges and agrees
                        that monetary damages may not be an adequate remedy for
                        a breach of this Section 13. A Party is entitled to seek
                        an injunction, or any other remedy available at law or
                        in equity, at its discretion, to protect itself from a
                        breach (or continuing breach) of this Section 13.
                      </p>

                      <p>
                        <strong>13.3</strong> This Section 13 will survive the
                        termination or expiry of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>14. Intellectual Property Rights</h6>

                      <p>
                        <strong>14.1</strong> A Party’s ownership of, or any
                        right, title or interest in, any Intellectual Property
                        Rights in an item which exists prior to the Effective
                        Date (“Pre-Existing Material”) will not be altered,
                        transferred or assigned by virtue of this Agreement.
                      </p>

                      <p>
                        <strong>14.2</strong> The Customer grants to the SaaS
                        Provider a non-exclusive, royalty free, non-transferable
                        and revocable license to use any of the Customer’s
                        Intellectual Property Rights including any Pre-Existing
                        Material as reasonably required for the SaaS Provider to
                        provide the Services to the Customer.
                      </p>

                      <p>
                        <strong>14.3</strong> We do not screen content uploaded
                        onto the SaaS Service, but we have the right (but not
                        the obligation) in our sole discretion to refuse or
                        remove any content that is available via the Service
                        that we deem inappropriate, illegal, offensive,
                        threatening, libelous, defamatory, obscene, or otherwise
                        objectionable or violate any party’s Intellectual
                        Property Rights or this Agreement.
                      </p>

                      <p>
                        <strong>14.4</strong> We have the discretion (but not
                        obligation) to terminate a Customer’s access to and use
                        of the Services if we determine that Customer or its
                        Authorized Users are repeat infringers of the
                        Intellectual Property Rights of ours or third parties.
                      </p>

                      <p>
                        <strong>14.5</strong> This Section 14 will survive the
                        termination or expiry of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>15. Privacy</h6>

                      <p>
                        <strong>15.1</strong> Each Party and its Personnel
                        agrees to comply with privacy guidelines as amended from
                        time to time in relation to personal information
                        collected, used or disclosed by that Party or its
                        Personnel in connection with the Services and this
                        Agreement.
                      </p>

                      <p>
                        <strong>15.2</strong> The SaaS Provider will take all
                        reasonable steps to notify the Customer in writing if it
                        becomes aware of any actual, threatened or suspected
                        breach of Data where such breach involves personal
                        information.
                      </p>

                      <p>
                        <strong>15.3</strong> The Customer warrants that it has
                        obtained each of its Personnel’s informed consent for
                        the Service Provider, to use, store, manipulate or
                        otherwise deal with the personal information contained
                        in the Data.
                      </p>

                      <p>
                        <strong>15.4</strong> The Customer must ensure that any
                        collection, processing, use, disclosure and transfer by
                        the Customer and its Personnel of personal information
                        in connection with the performance of its obligations
                        under this Agreement complies with all applicable
                        privacy law and the privacy policy of the Customer.
                      </p>

                      <p>
                        <strong>15.5</strong> The Customer must take all
                        necessary steps to ensure that the personal information
                        held or accessed by it in connection with this Agreement
                        is protected against misuse, interference and loss, and
                        from unauthorized access, modification and disclosure
                        (Data Breach). The Customer will promptly give written
                        notice to the Service Provider of any actual or
                        suspected Data Breach and will provide information,
                        assistance and other cooperation as requested by the
                        Service Provider in respect of the Data Breach.
                      </p>

                      <p>
                        <strong>15.6</strong> The Customer must co-operate with
                        any reasonable requests or directions of the Service
                        Provider relating to the security, use, disclosure, and
                        transfer of personal information, the Service Provider’s
                        legal obligations relating to the personal information,
                        complaints relating to the personal information and the
                        rights of individuals to access and correct the personal
                        information or opt out of receiving any communications
                        from or on behalf of the Customer.
                      </p>

                      <p>
                        <strong>15.7</strong> The Service Provider will retain
                        Customer’s information for as long as Customer account
                        is active or as needed to provide Customer services.
                        Service Provider will retain and use information as
                        necessary to comply with legal obligations, resolve
                        disputes, and enforce agreements.
                      </p>

                      <p>
                        <strong>15.8</strong> This Section 15 will survive the
                        termination or expiry of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>16. Representations and Warranties</h6>

                      <p>
                        <strong>16.1 General</strong>
                      </p>

                      <p>
                        <strong>a.</strong> Each Party represents and warrants
                        to each other Party that:
                      </p>

                      <ol type="i">
                        <li>
                          it has full legal capacity and power to enter into
                          this Agreement, to perform its obligations under this
                          Agreement to carry out the transactions contemplated
                          by this Agreement, to own its property and assets and
                          to carry on its business;
                        </li>

                        <li>
                          no Insolvency Event has occurred in respect of it;
                        </li>

                        <li>
                          this Agreement constitutes legal, valid and binding
                          obligations, enforceable in accordance with its terms;
                          and
                        </li>

                        <li>
                          the execution and performance by it of this Agreement
                          and each transaction contemplated by it does not
                          conflict with any law, order, judgment, rule or
                          regulation applicable to it or any document binding on
                          it.
                        </li>
                      </ol>

                      <p>
                        <strong>b. SaaS Provider</strong>
                      </p>

                      <ol type="i">
                        <li>
                          The SaaS Provider warrants that to the best of its
                          knowledge the Services do not infringe the
                          Intellectual Property Rights of any third party and
                          there are no actual or threatened proceedings for any
                          intellectual property infringements in relation to the
                          SaaS Services.
                        </li>

                        <li>
                          The SaaS Provider does not warrant that the Services
                          will be error-free or will operate without
                          interruption or that, except as set out in this
                          Agreement, the Services will be performed in the
                          manner intended by the Customer or the Services will
                          meet the requirements of the Customer.
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>17. Indemnity</h6>
                      <p>
                        <strong>17.1</strong> The SaaS Provider is liable for
                        the acts and omissions of all its Personnel as if they
                        were done by the SaaS Provider.
                      </p>
                      <p>
                        <strong>17.2</strong> Despite anything to the contrary
                        (but subject to Section 17.3), to the maximum extent
                        permitted by the law:
                      </p>
                      <ol type="a">
                        <li>
                          The SaaS Provider’s maximum aggregate Liability
                          arising from or in connection with this Agreement
                          (including the Services or the subject matter of this
                          Agreement) will be limited to, and must not exceed, in
                          any Contract Year, the total amount of Fees paid to
                          SaaS Provider in the prior Contract Year; and
                        </li>

                        <li>
                          The SaaS Provider will not be liable to the Customer
                          for:
                          <ol type="i">
                            <li>
                              any loss of profit (including anticipated profit),
                              loss of revenue, loss of business, loss of
                              goodwill, loss of opportunity, loss of savings
                              (including anticipated savings), loss of
                              reputation, loss of use and/or loss or corruption
                              of data) or for any indirect, special, incidental,
                              punitive, or consequential damages or damage to
                              goodwill however caused and, whether in contract,
                              tort or under any other theory of liability,
                              whether or not the Customer has been advised of
                              the possibility of such damages;
                            </li>

                            <li>
                              lack of access to or use of or inability to access
                              or use the Service;
                            </li>

                            <li>
                              any conduct or content of any third party on the
                              Services;
                            </li>

                            <li>any content obtained from the Services; nor</li>

                            <li>
                              unauthorized access, use or alteration of your
                              transmissions or content, whether under statute,
                              contract, equity, tort (including negligence),
                              indemnity or otherwise.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <p>
                        <strong>17.3</strong> Section 17.2 will not apply to the
                        SaaS Provider’s Liability to the Customer under this
                        Agreement for any liability which cannot be excluded or
                        limited by applicable law, including:
                      </p>
                      <ol type="a">
                        <li>fraud or criminal conduct; or</li>

                        <li>death or personal injury.</li>
                      </ol>
                      <p>
                        <strong>17.4</strong> Despite anything to the contrary,
                        to the maximum extent permitted by the law, the SaaS
                        Provider will have no Liability, and the Customer
                        releases and discharges the SaaS Provider from all
                        Liability, arising from or in connection with any:
                      </p>
                      <ol type="a">
                        <li>failure or delay in providing the Services;</li>

                        <li>breach of this Agreement; or</li>

                        <li>misuse of the Services,</li>
                      </ol>
                      <strong>17.5</strong> where caused or contributed to by
                      any:
                      <ol type="a">
                        <li>Force Majeure Event;</li>

                        <li>
                          a fault or defect in any item of the Customer
                          Environment; or
                        </li>

                        <li>
                          act or omission of the Customer or its Personnel.
                        </li>
                      </ol>
                      <p>
                        <strong>17.6</strong> The SaaS Provider uses third-party
                        Service Providers to host the Services. The SaaS
                        Provider will not be liable for any interruption to the
                        Services, unavailability or outage, or any interruption,
                        unavailability or outage of the Customer’s Systems,
                        caused by any such third-party service provider.
                      </p>
                      <p>
                        <strong>17.7</strong> The Customer agrees that, to the
                        maximum extent permitted by the law, this Agreement
                        excludes all terms, conditions and warranties implied by
                        statute, in fact or on any other basis, except to the
                        extent such terms, conditions and warranties are fully
                        expressed in this Agreement.
                      </p>
                      <p>
                        <strong>17.8</strong> The Customer agrees to indemnify,
                        and hold harmless, the Service Provider against all
                        Liabilities and Claims arising out of or in connection
                        with:
                      </p>
                      <ol type="a">
                        <li>
                          any and all unauthorized use of the SaaS Service;
                        </li>

                        <li>
                          injury to or death of any person caused by any act or
                          omission by or on behalf of the Customer or its
                          Personnel; and
                        </li>

                        <li>
                          damage to any real or tangible property caused by any
                          act or omission by or on behalf of the Customer or its
                          personnel.
                        </li>
                      </ol>
                      <p>
                        <strong>17.9</strong> This Section 17 will survive the
                        termination or expiry of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>18. Term</h6>

                      <h6>18.1 Commencement</h6>

                      <ol type="a">
                        <li>
                          The Term of this Agreement takes effect on and from
                          the Effective Date and continues for the Initial Term,
                          if specified, and any Renewal Term, or otherwise
                          indefinitely, unless this Agreement is terminated
                          earlier in accordance with the terms of this
                          Agreement.
                        </li>

                        <li>
                          At least 30 days prior to the expiry of the current
                          Contract Year, either Party may notify the other that
                          it does not wish for the Term to be renewed and in
                          such event, this Agreement will expire at the end of
                          the then current Contract Year. If a Party has not
                          given notice pursuant to this Section, this Agreement
                          is automatically renewed for another 12-month period
                          (“Renewal Term”).
                        </li>
                      </ol>
                    </div>

                    <div>
                      <h6>19. Termination</h6>

                      <p>
                        <strong>19.1</strong> Customer may terminate this
                        Agreement by giving SaaS Provider at least 30 days prior
                        written notice, such termination will take effect at the
                        expiry of the then current billing cycle.
                      </p>

                      <p>
                        <strong>19.2</strong> The Customer may terminate this
                        Agreement by giving at least 30 Business Days’ notice to
                        the SaaS Provider, or if the SaaS Provider is in breach
                        (other than a trivial breach causing no material harm)
                        of any provision of this Agreement and, where the breach
                        is capable of remedy, the SaaS Provider has failed to
                        remedy the breach within 30 Business Days’ of receipt of
                        written notice from the Customer describing the breach
                        and calling for it to be remedied.
                      </p>

                      <p>
                        <strong>19.3</strong> The SaaS Provider may terminate
                        this Agreement by giving at least 30 Business Days’
                        notice to the Customer if the Customer is in breach
                        (other than a trivial breach causing no material harm)
                        of any provision of this Agreement and, where the breach
                        is capable of remedy, the Customer has failed to remedy
                        the breach within 30 Business Days of receipt of written
                        notice from the SaaS Provider describing the breach and
                        calling for it to be remedied.
                      </p>

                      <p>
                        <strong>19.4</strong> The SaaS Provider may terminate
                        this Agreement immediately by giving written notice to
                        Customer where:
                      </p>

                      <ol type="a">
                        <li>
                          the Customer undergoes a change of control to a
                          competitor of the SaaS Provider as determined by the
                          SaaS Provider;
                        </li>

                        <li>
                          an Insolvency Event occurs in relation to the
                          Customer;
                        </li>

                        <li>
                          the Customer commits a breach of this Agreement not
                          capable of remedy; or breaches Section 5 (License
                          Restrictions) or Section 10 (Prohibited Use).
                        </li>
                      </ol>

                      <p>
                        <strong>19.5</strong> The SaaS Provider may suspend
                        overdue accounts without notice to the Customer.
                      </p>
                    </div>

                    <div>
                      <h6>20. Events Following Termination</h6>

                      <p>
                        <strong>20.1</strong> Upon termination of this
                        Agreement, the SaaS Provider will:
                      </p>

                      <ol type="a">
                        <li>immediately stop performing the Services;</li>

                        <li>
                          immediately stop placing orders for supplies or
                          services required in connection with the performance
                          of the Services; and
                        </li>

                        <li>
                          promptly return to the Customer or destroy all
                          property, including Confidential Information,
                          Intellectual Property, and Data in its possession that
                          belongs to the Customer.
                        </li>
                      </ol>

                      <p>
                        <strong>20.2</strong> Upon termination of this
                        Agreement, the Customer will immediately:
                      </p>

                      <ol type="a">
                        <li>cease and desist from any use of the Services;</li>

                        <li>
                          return to the SaaS Provider all property, including
                          Confidential Information and Intellectual Property, in
                          its possession that belongs to the SaaS Provider;
                        </li>

                        <li>pay the Fees for all Services completed;</li>
                      </ol>

                      <p>
                        <strong>20.3</strong> The expiry or termination of this
                        Agreement for any reason will be without prejudice to
                        any rights or liabilities which have accrued prior to
                        the date of expiry or termination of this Agreement.
                      </p>

                      <p>
                        <strong>20.4</strong> This Section 20 will survive the
                        termination or expiry of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>21. Governing Law and Dispute Resolution</h6>

                      <p>
                        {" "}
                        If there is any dispute between the Parties arising out
                        of this Agreement (a “Dispute”), then authorized
                        representatives of each Party will negotiate in good
                        faith to resolve the Dispute. If such representatives
                        cannot resolve the Dispute after 30 days of good faith
                        negotiations or if a Party fails to participate in good
                        faith efforts to resolve the Dispute, then the Dispute
                        shall be determined by binding arbitration in New York,
                        NY. The arbitration shall be conducted in accordance
                        with the Commercial Arbitration Rules of the American
                        Arbitration Association (“AAA”) in effect at the time of
                        the Dispute, subject to any modifications contained in
                        this Agreement. The Dispute shall be determined by one
                        arbitrator. The award shall be in writing and include
                        the findings of fact and conclusions of law upon which
                        it is based. The Parties knowingly and voluntarily waive
                        their rights to have any Dispute tried and adjudicated
                        by a judge or a jury. The arbitration shall be governed
                        by the substantive laws of the State of Delaware,
                        without regard to conflicts-of-law rules, and by the
                        arbitration law of the Federal Arbitration Act (Title 9,
                        U.S. Code). Judgment upon the award rendered may be
                        entered in any court having jurisdiction. Except as
                        otherwise required by law, the Parties and the
                        arbitrator(s) agree to keep confidential and not
                        disclose to third parties any information or documents
                        obtained in connection with the arbitration process,
                        including the resolution of the Dispute. The prevailing
                        party shall be entitled to be awarded costs, including
                        reasonable attorney’s fees, paid or incurred in
                        successfully compelling and/or participating in such
                        arbitration and/or successfully defending or enforcing
                        the award. Customer may bring claims only on its own
                        behalf and agrees that it shall not participate in any
                        class action or class-wide arbitration or any
                        consolidated claims arising from or related to this
                        Agreement or which name SaaS Provider as a party to the
                        proceeding. Any provision of applicable law
                        notwithstanding, the arbitrator will not have authority
                        to award damages, remedies or awards that conflict with
                        this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>22. Subcontracting</h6>

                      <p>
                        {" "}
                        The Parties agree the SaaS Provider may engage
                        subcontractors to perform the Services on its behalf.
                      </p>
                    </div>

                    <div>
                      <h6>23.Non-Solicitation</h6>

                      <p>
                        {" "}
                        <strong>23.1</strong> The Customer will not solicit or
                        entice away, any person or organization that was an
                        actual or prospective, client, employee, contractor,
                        representative, agent of, or developer to, the SaaS
                        Provider, during the Term of this Agreement and for a
                        period of 1 year thereafter.
                      </p>

                      <p>
                        <strong>23.2</strong> This Section 23 will survive the
                        termination or expiry of this Agreement.
                      </p>
                    </div>

                    <div>
                      <h6>24. General</h6>

                      <h6>24.1 Notices</h6>

                      <p>
                        a. A notice or other communication given under this
                        Agreement must be:
                      </p>

                      <ol>
                        <li>
                          i. in writing, in English and signed by the sender;
                          and
                        </li>

                        <li>
                          ii. addressed and delivered to the intended recipient
                          by hand, prepaid post or email in accordance with the
                          notice details last notified by the recipient to the
                          Parties.
                        </li>
                      </ol>

                      <p>
                        b. The Customer’s notice details are set out in the
                        Customer’s account. The SaaS Provider’s notice details
                        are set out on the Site. A Party may change its notice
                        details by written notice to the other Parties, which,
                        for the Customer, is by updating their Account, and for
                        SaaS Provider, is by updating the Site.
                      </p>

                      <p>
                        c. A notice or communication is taken as having been
                        given:
                      </p>

                      <ol>
                        <li>
                          i. when left at a Party’s current address for notices;
                        </li>

                        <li>
                          ii. if mailed, on the third Business Day after posting
                          (if delivered to an address within the same country)
                          or on the tenth Business Day after posting (if
                          delivered to an address within another country); or
                        </li>

                        <li>
                          iii. if sent by email, if sent before 5 pm on a
                          Business Day in the place of receipt then on the
                          Business Day when it is sent, otherwise on the
                          following Business Day.
                        </li>
                      </ol>

                      <p>
                        d. This subsection will survive the termination or
                        expiry of this Agreement.
                      </p>

                      <h6>24.2 Force Majeure</h6>

                      <p>
                        If performance of this Agreement or any obligation under
                        this Agreement is prevented, restricted or interfered
                        with by reasons of Force Majeure and the affected Party
                        unable to carry out its obligations gives the other
                        Party prompt written notice of such event, then the
                        obligations of the affected party invoking this
                        provision shall be suspended to the extent necessary by
                        such event. The affected Party shall use reasonable
                        efforts under the circumstances to remove such
                        prevention, restriction or interference or to limit the
                        impact of the event on its performance and must continue
                        to perform with reasonable dispatch when the Force
                        Majeure is removed.
                      </p>

                      <h6>24.3 Waiver</h6>

                      <p>
                        Any failure or delay by a Party in exercising a power or
                        right (either wholly or partially) in relation to this
                        Agreement does not operate as a waiver or prevent that
                        Party from exercising that power or right or any other
                        power or right. A waiver must be in writing.
                      </p>

                      <h6>24.4 Powers, Rights, and Remedies</h6>

                      <p>
                        Except as provided in this Agreement or permitted by
                        law, the powers, rights, and remedies of a Party under
                        this Agreement are cumulative and in addition to any
                        other powers, rights and remedies the Party may have.
                      </p>

                      <h6>24.5 Assignment</h6>

                      <p>
                        No Party may assign, transfer or otherwise deal with all
                        or any of its rights or obligations under this Agreement
                        without the prior written consent of the other Party.
                        Any purported dealing in breach of this Section 24.6 is
                        of no force or effect.
                      </p>

                      <h6>24.6 Further Assurance</h6>

                      <p>
                        Each Party must promptly do all things and execute all
                        further documents necessary to give full force and
                        effect to this Agreement and their obligations under it.
                        This subsection will survive the termination or expiry
                        of this Agreement.
                      </p>

                      <h6>24.7 Relationship of Parties</h6>

                      <p>
                        This Agreement is not intended to create a partnership,
                        joint venture or agency relationship between the
                        Parties. Nothing in this Agreement gives a Party
                        authority to bind any other Party in any way.
                      </p>

                      <h6>24.8 Links to Third Parties</h6>

                      <p>
                        The Services may contain links to third-party web sites
                        or services that are not owned or controlled by the SaaS
                        Provider. The SaaS Provider has no control over, and
                        assumes no responsibility for, the content, privacy
                        policies, or practices of any third party web sites or
                        services. The Customer further acknowledges and agrees
                        that the SaaS Provider shall not be responsible or
                        liable, directly or indirectly, for any damage or loss
                        caused or alleged to be caused by or in connection with
                        use of or reliance on any such content, goods or
                        services available on or through any such web sites or
                        services.
                      </p>

                      <h6>24.9 Independent Legal Advice</h6>

                      <p>
                        Each Party acknowledges and agrees that it has had an
                        opportunity to read this Agreement, it agrees to its
                        terms and, prior to executing it, it has been provided
                        with the opportunity to seek independent legal advice
                        about its terms.
                      </p>

                      <h6>24.10 Severance</h6>

                      <p>
                        If a provision of this Agreement is held to be void,
                        invalid, illegal or unenforceable, that provision must
                        be read down as narrowly as necessary to allow it to be
                        valid or enforceable. If it is not possible to read down
                        a provision (in whole or in part), that provision (or
                        that part of that provision) is severed from this
                        Agreement without affecting the validity or
                        enforceability of the remainder of that provision or the
                        other provisions in this Agreement.
                      </p>

                      <h6>24.11 Entire Agreement</h6>

                      <p>
                        The Agreement contains the entire understanding between
                        the Parties, and supersedes all previous discussions,
                        communications, negotiations, understandings,
                        representations, warranties, commitments and agreements,
                        in respect of its subject matter.
                      </p>

                      <h6>24.12 Cumulative Rights</h6>

                      <p>
                        The rights arising out of this Agreement do not exclude
                        any other rights of either Party. Each indemnity in this
                        Agreement is a continuing obligation that is separate
                        and independent from the other obligations of the
                        Parties under this Agreement. A Party is not obliged to
                        take any action, or incur any expense, before enforcing
                        any indemnity under this Agreement.
                      </p>
                    </div>
                  </div>
                  <div>
                    <h4 className="main-heading">Website Terms of Use </h4>
                    <div>
                      <h6>Acceptance of the Terms of Use</h6>
                      <p>
                        These terms of use are entered into by and between You
                        and Verastel, Inc. ("Company", "we" or "us").
                        Thefollowing terms and conditions, together with any
                        documents they expressly incorporate by
                        reference(collectively, these "Terms of Use"), govern
                        your access to and use of this website, including any
                        content,functionality and services offered on or through
                        this website and any other Company website listed here
                        (the"Website") whether as a guest or a registered user.
                      </p>

                      <p>
                        Please read these Terms of Use carefully before you
                        start to use the Website. By using the Websites, you
                        accept and agree to be bound and abide by these Terms of
                        Use and our Privacy Policy, incorporated herein by
                        reference. If you do not want to agree to these Terms of
                        Use or the Privacy Policy, you must not access or use
                        the Website.
                      </p>

                      <p>
                        BY ACCESSING AND USING THIS WEBSITE OR ANY RELATED
                        SERVICES, YOU, ON BEHALF OF YOURSELF AND THE ENTITY YOU
                        REPRESENT, ACKNOWLEDGE AND AGREE TO THESE TERMS OF USE.
                        THIS APPLIES IF YOU ARE AN INDIVIDUAL EMPLOYEE, AGENT,
                        OR REPRESENTATIVE OF A CORPORATION, PARTNERSHIP, OR
                        OTHER LEGAL ENTITY AND HAVE THE AUTHORITY TO BIND SUCH
                        ENTITY TO THESE TERMS. YOU CONFIRM THAT YOUR USE OF THE
                        WEBSITE AND SERVICES IS IN COMPLIANCE WITH ALL
                        APPLICABLE LAWS AND REGULATIONS IN YOUR JURISDICTION AND
                        THAT YOU ARE NOT PROHIBITED FROM ACCESSING,
                        PARTICIPATING IN, OR RECEIVING INFORMATION FROM THE
                        WEBSITE OR THROUGH ANY OF OUR SERVICES UNDER ANY
                        APPLICABLE LAWS.
                      </p>
                    </div>

                    <div>
                      <h6>Changes to the Terms of Use</h6>

                      <p>
                        We may revise and update these Terms of Use from time to
                        time at our sole discretion. All changes are effective
                        immediately when we post them and apply to all access to
                        and use of the Website thereafter. However, any changes
                        to the dispute resolution provisions set forth in
                        Governing Law and Jurisdiction will not apply to any
                        disputes for which the parties have actual notice on or
                        prior to the date the change is posted on the Website.
                      </p>

                      <p>
                        Your continued use of the Website, following the posting
                        of revised Terms of Use, means that you accept and agree
                        to the changes. You are expected to check this page from
                        time to time, so you are aware of any changes, as they
                        are binding on you.
                      </p>
                    </div>

                    <div>
                      <h6>Accessing the Website and Account Security</h6>

                      <p>
                        We reserve the right to withdraw or amend this Website,
                        and any service or material we provide on the Website,
                        at our sole discretion without notice. We will not be
                        liable if, for any reason, all or any part of the
                        Website is unavailable at any time or for any period.
                        From time to time, we may restrict access to some parts
                        of the Website or the entire Website to users, including
                        registered users.
                      </p>

                      <p>You are responsible for:</p>

                      <ul>
                        <li>
                          Making all arrangements necessary for you to have
                          access to the Website.
                        </li>

                        <li>
                          Ensuring that all persons who access the Website
                          through your internet connection are aware of these
                          Terms of Use and comply with them.
                        </li>
                      </ul>

                      <p>
                        To access the Website or some of the resources it
                        offers, you may be asked to provide certain registration
                        details or other information. It is a condition of your
                        use of the Website that all the information you provide
                        on the Website is correct, current, and complete. You
                        agree that all information you provide to register with
                        this Website or otherwise, including but not limited to
                        through the use of any interactive features on the
                        Website, is governed by our Privacy Policy, and you
                        consent to all actions we take with respect to your
                        information consistent with our Privacy Policy.
                      </p>

                      <p>
                        If you choose, or are provided with, a user name,
                        password, or any other piece of information as part of
                        our security procedures, you must treat such information
                        as confidential, and you must not disclose it to any
                        other person or entity. You also acknowledge that your
                        account is personal to you and agree not to provide any
                        other person with access to this Website or portions of
                        it using your user name, password, or other security
                        information. You agree to notify us immediately of any
                        unauthorized access to or use of your user name or
                        password, or any other breach of security.
                      </p>

                      <p>
                        You also agree to ensure that you exit from your account
                        at the end of each session. You should use particular
                        caution when accessing your account from a public or
                        shared computer so that others are not able to view or
                        record your password or other personal information.
                      </p>

                      <p>
                        We have the right to disable any user name, password, or
                        other identifier, whether chosen by you or provided by
                        us, at any time at our sole discretion, for any or no
                        reason, including if, in our opinion, you have violated
                        any provision of these Terms of Use.
                      </p>
                    </div>

                    <div>
                      <h6>Intellectual Property Rights</h6>

                      <p>
                        The Website and its entire contents, features, and
                        functionality (including but not limited to all
                        information, software, text, displays, images, and video
                        and audio files, and the design, selection and
                        arrangement thereof), are owned by the Company, its
                        licensors, or other providers of such material and are
                        protected by United States and international copyright,
                        trademark, patent, trade secret, and other intellectual
                        property or proprietary rights laws.
                      </p>

                      <p>
                        These Terms of Use grant your organization permission to
                        access and use the Website solely for its internal
                        business operations and purposes. Commercial use is
                        permitted within the scope of your organization's
                        business activities. You must not reproduce, distribute,
                        modify, create derivative works of, publicly display,
                        publicly perform, republish, download, store, or
                        transmit any of the material on our Website, except as
                        follows:
                      </p>

                      <ul>
                        <li>
                          Your computer may temporarily store copies of such
                          materials in RAM incidental to your accessing and
                          viewing those materials.
                        </li>

                        <li>
                          You may store files that are automatically cached by
                          your Web browser for display enhancement purposes.
                        </li>

                        <li>
                          If we provide desktop, mobile, or other applications
                          for download, your organization may download and
                          install copies on your company's computers or assets
                          strictly for internal business use. This is contingent
                          upon your agreement to comply with our End User
                          License Agreement applicable to such applications,
                          which governs the use within your corporate
                          environment.
                        </li>

                        <li>
                          All downloadable materials, including .pdfs that are
                          not accompanied by an End User License Agreement,
                          remain the intellectual property of the Company. These
                          materials may be used within your organization solely
                          for internal, business-related purposes.
                        </li>
                      </ul>

                      <p>You must not:</p>

                      <ul>
                        <li>Modify copies of any materials from this site.</li>

                        <li>
                          Delete or alter any copyright, trademark, or other
                          proprietary rights notices from copies of materials
                          from this site.
                        </li>
                      </ul>

                      <p>
                        Your organization is permitted to access and use the
                        Website and any services or materials available through
                        it solely for legitimate internal business purposes, in
                        accordance with the terms and conditions set forth
                        herein. If you wish to make any use of material on the
                        Website other than that set out in this section, please
                        address your request to: ___________.
                      </p>

                      <p>
                        If you print, copy, modify, download, or otherwise use
                        or provide any other person with access to any part of
                        the Website in breach of the Terms of Use, your right to
                        use the Website will cease immediately and you must, at
                        our option, return or destroy any copies of the
                        materials you have made. No right, title, or interest in
                        or to the Website or any content on the Website is
                        transferred to you, and all rights not expressly granted
                        are reserved by the Company. Any use of the Website not
                        expressly permitted by these Terms of Use is a breach of
                        these Terms of Use and may violate copyright, trademark,
                        and other laws.
                      </p>
                    </div>

                    <div>
                      <h6>Trademarks</h6>

                      <p>
                        Verastel and its logo, the terms SPARK, SNoOPs, and any
                        and all other names, logos, product and service, designs
                        or slogans used by the Company, and the look and feel of
                        any of the foregoing, including all page headers, custom
                        graphics, button icons, and scripts are trademarks or
                        trade dress of the Company and may not be used in whole
                        or in part in connection with any product or service
                        that is not or does not belong to the Company or in any
                        manner that is likely to cause confusion among
                        customers, or in any manner that disparages or
                        discredits the Company, without our prior written
                        permission.
                      </p>

                      <p>
                        All other names, logos, product and service names,
                        designs, and slogans on this Website are the property of
                        their respective owners, and any reference to such other
                        property does not constitute or imply endorsement,
                        sponsorship, or recommendation thereof by us or any
                        other affiliation.
                      </p>
                    </div>

                    <div>
                      <h6>Prohibited Uses</h6>

                      <p>
                        You may use the Website only for lawful purposes and in
                        accordance with these Terms of Use. You agree not to use
                        the Website:
                      </p>

                      <ul>
                        <li>
                          In any way that violates any applicable federal,
                          state, local, or international law or regulation
                          (including, without limitation, any laws regarding the
                          export of data or software to and from the U.S. or
                          other countries) or if we have previously disabled
                          your account for violation of law or any of our
                          policies.
                        </li>

                        <li>
                          To transmit, or procure the sending of, any
                          advertising or promotional material without our prior
                          written consent, including any "junk mail", "chain
                          letter", "spam", or any other similar solicitation.
                        </li>

                        <li>
                          To impersonate or attempt to impersonate the Company,
                          a Company employee, another user, or any other person
                          or entity (including, without limitation, by using
                          e-mail addresses or screen names associated with any
                          of the foregoing).
                        </li>

                        <li>
                          To engage in any other conduct that restricts or
                          inhibits anyone's use or enjoyment of the Website, or
                          which, as determined by us, may harm the Company or
                          users of the Website or expose them to liability.
                        </li>
                      </ul>

                      <p>In addition, you agree not to:</p>

                      <ul>
                        <li>
                          Use the Website in any manner that could disable,
                          overburden, damage, or impair the site or interfere
                          with any other party's use of the Website, including
                          their ability to engage in real time activities
                          through the Website.
                        </li>

                        <li>
                          Use any robot, spider, or other automatic asset,
                          process, or means to access the Website for any
                          purpose, including monitoring or copying any of the
                          material on the Website.
                        </li>

                        <li>
                          Use any manual process to monitor or copy any of the
                          material on the Website or for any other unauthorized
                          purpose without our prior written consent.
                        </li>

                        <li>
                          Use any asset, software, or routine that interferes
                          with the proper working of the Website.
                        </li>

                        <li>
                          Introduce any viruses, Trojan horses, worms, logic
                          bombs, or other material which is malicious or
                          technologically harmful.
                        </li>

                        <li>
                          Attempt to gain unauthorized access to, interfere
                          with, damage, or disrupt any parts of the Website, the
                          server on which the Website is stored, or any server,
                          computer, or database connected to the Website.
                        </li>

                        <li>
                          Attack the Website via a denial-of-service attack or a
                          distributed denial-of- service attack.
                        </li>

                        <li>
                          Otherwise attempt to interfere with the proper working
                          of the Website.
                        </li>
                      </ul>
                    </div>

                    <div>
                      <h6>User Contributions</h6>

                      <p>
                        The Website may contain message boards, chat rooms,
                        personal web pages or profiles, forums, bulletin boards
                        and other interactive features (collectively,
                        "Interactive Services") that allow users to post,
                        submit, publish, display, or transmit to other users or
                        other persons (hereinafter, "post") content or materials
                        (collectively, "User Contributions") on or through the
                        Website.
                      </p>

                      <p>
                        All User Contributions must comply with the Content
                        Standards set out in these Terms of Use.
                      </p>

                      <p>
                        Any User Contribution you post to the site will be
                        considered non-confidential and non-proprietary. By
                        providing any User Contribution on the Website, you
                        grant us and our respective licensees, successors, and
                        assigns the right to use, reproduce, modify, perform,
                        display, distribute, and otherwise disclose to third
                        parties any such material for any purpose.
                      </p>

                      <p>You represent and warrant that:</p>

                      <ul>
                        <li>
                          You own or control all rights in and to the User
                          Contributions and have the right to grant the license
                          granted above to us and our licensees, successors, and
                          assigns.
                        </li>

                        <li>
                          All of your User Contributions do and will comply with
                          these Terms of Use.
                        </li>
                      </ul>

                      <p>
                        You understand and acknowledge that you are responsible
                        for any User Contributions you submit or contribute, and
                        you, not the Company, have full responsibility for such
                        content, including its legality, reliability, accuracy,
                        and appropriateness.
                      </p>

                      <p>
                        We are not responsible or liable to any third party for
                        the content or accuracy of any User Contributions posted
                        by you or any other user of the Website.
                      </p>
                    </div>

                    <div>
                      <h6>Monitoring and Enforcement; Termination</h6>

                      <p>We have the right to:</p>

                      <ul>
                        <li>
                          Remove or refuse to post any User Contributions for
                          any or no reason in our sole discretion.
                        </li>

                        <li>
                          Take any action with respect to any User Contribution
                          that we deem necessary or appropriate in our sole
                          discretion, including if we believe that such User
                          Contribution violates the Terms of Use, including the
                          Content Standards, infringes on any intellectual
                          property right or other right of any person or entity,
                          threatens the personal safety of users of the Website
                          or the public, or could create liability for the
                          Company.
                        </li>

                        <li>
                          Disclose your identity or other information about you
                          to any third party who claims that material posted by
                          you violates their rights, including their
                          intellectual property rights or their right to
                          privacy.
                        </li>

                        <li>
                          Take appropriate legal action, including without
                          limitation, referral to law enforcement, for any
                          illegal or unauthorized use of the Website.
                        </li>

                        <li>
                          Terminate or suspend your access to all or part of the
                          Website for any or no reason, including without
                          limitation, any violation of these Terms of Use.
                        </li>
                      </ul>

                      <p>
                        Without limiting the foregoing, we have the right to
                        cooperate fully with any law enforcement authorities or
                        court order requesting or directing us to disclose the
                        identity or other information of anyone posting any
                        materials on or through the Website. YOU WAIVE AND HOLD
                        HARMLESS THE COMPANY FROM ANY CLAIMS RESULTING FROM ANY
                        ACTION TAKEN BY THE COMPANY DURING OR AS A RESULT OF ITS
                        INVESTIGATIONS, AND FROM ANY ACTIONS TAKEN AS A
                        CONSEQUENCE OF INVESTIGATIONS BY EITHER THE COMPANY OR
                        LAW ENFORCEMENT AUTHORITIES.
                      </p>

                      <p>
                        However, we cannot review all material before it is
                        posted on the Website, and cannot ensure prompt removal
                        of objectionable material after it has been posted.
                        Accordingly, we assume no liability for any action or
                        inaction regarding transmissions, communications, or
                        content provided by any user or third party. We have no
                        liability or responsibility to anyone for performance or
                        non-performance of the activities described in this
                        section.
                      </p>
                    </div>

                    <div>
                      <h6>Content Standards</h6>

                      <p>
                        These content standards apply to any and all User
                        Contributions and use of Interactive Services. User
                        Contributions must in their entirety comply with all
                        applicable federal, state, local, and international laws
                        and regulations. Without limiting the foregoing, User
                        Contributions must not:
                      </p>

                      <ul>
                        <li>
                          Contain any material which is defamatory, obscene,
                          indecent, abusive, offensive, harassing, violent,
                          hateful, inflammatory, or otherwise objectionable.
                        </li>

                        <li>
                          Infringe any patent, trademark, trade secret,
                          copyright, or other intellectual property or other
                          rights of any other person.
                        </li>

                        <li>
                          Violate the legal rights (including the rights of
                          publicity and privacy) of others or contain any
                          material that could give rise to any civil or criminal
                          liability under applicable laws or regulations, or
                          that otherwise may be in conflict with these Terms of
                          Use and our Privacy Policy.
                        </li>

                        <li>Be likely to deceive any person.</li>

                        <li>
                          Promote any illegal activity, or advocate, promote or
                          assist any unlawful act.
                        </li>

                        <li>
                          Impersonate any person, or misrepresent your identity
                          or affiliation with any person or organization.
                        </li>

                        <li>
                          Involve commercial activities or sales, such as
                          contests, sweepstakes and other sales promotions,
                          barter, or advertising.
                        </li>

                        <li>
                          Give the impression that they emanate from or are
                          endorsed by the Company or any other person or entity,
                          if this is not the case.
                        </li>
                      </ul>
                    </div>

                    <div>
                      <h6>Reliance on Information Posted</h6>

                      <p>
                        The information presented on or through the Website is
                        made available solely for general information purposes.
                        We do not warrant the accuracy, completeness, or
                        usefulness of this information. Any reliance you place
                        on such information is strictly at your own risk. We
                        disclaim all liability and responsibility arising from
                        any reliance placed on such materials by you or any
                        other visitor to the Website, or by anyone who may be
                        informed of any of its contents.
                      </p>

                      <p>
                        This Website may include content provided by third
                        parties, including materials provided by other users,
                        bloggers and third-party licensors, syndicators,
                        aggregators, and/or reporting services. All statements
                        and/or opinions expressed in these materials, and all
                        articles and responses to questions and other content,
                        other than the content provided by the Company, are
                        solely the opinions and the responsibility of the person
                        or entity providing those materials. These materials do
                        not necessarily reflect the opinion of the Company. We
                        are not responsible, or liable to you or any third
                        party, for the content or accuracy of any materials
                        provided by any third parties.
                      </p>
                    </div>

                    <div>
                      <h6>Changes to the Website</h6>

                      <p>
                        We may update the content on this Website from time to
                        time, but its content is not necessarily complete or
                        up-to-date. Any of the material on the Website may be
                        out of date at any given time, and we are under no
                        obligation to update such material.
                      </p>
                    </div>

                    <div>
                      <h6>
                        Information About You and Your Visits to the Website
                      </h6>

                      <p>
                        All information we collect on this Website is subject to
                        our Privacy Policy. By using the Website, you consent to
                        all actions taken by us with respect to your information
                        in compliance with the Privacy Policy.
                      </p>
                    </div>

                    <div>
                      <h6>Online Purchases and Other Terms and Conditions</h6>

                      <p>
                        All purchases through our site or other transactions for
                        the sale of services formed through the Website or as a
                        result of visits made by you are governed by our SaaS
                        Agreement which is hereby incorporated into these Terms
                        of Use.
                      </p>

                      <p>
                        Additional terms and conditions may also apply to
                        specific portions, services, or features of the Website.
                        All such additional terms and conditions are hereby
                        incorporated by this reference into these Terms of Use.
                      </p>
                    </div>

                    <div>
                      <h6>Links from the Website</h6>

                      <p>
                        If the Website contains links to other websites and
                        resources provided by third parties, these links are
                        provided for your convenience only. This may include
                        links contained in advertisements, including banner
                        advertisements and sponsored links. We have no control
                        over the contents of those sites or resources and accept
                        no responsibility for them or for any loss or damage
                        that may arise from your use of them. If you decide to
                        access any of the third-party websites linked to this
                        Website, you do so entirely at your own risk and subject
                        to the terms and conditions of use for such websites.
                      </p>
                    </div>

                    <div>
                      <h6>Geographic Restrictions</h6>

                      <p>
                        The owner of the Website is based in the state of
                        ________ in the United States. While this Website is
                        primarily intended for users within the United States,
                        it may be accessible to users globally. However, we do
                        not represent that the Website or its content is
                        suitable, legal, or available for use in locations
                        outside the United States. If you access the Website
                        from outside the United States, you are responsible for
                        ensuring compliance with all applicable local and
                        international laws and regulations.
                      </p>

                      <p>
                        Your decision to access and use the Website is made
                        independently and at your own risk, and you must ensure
                        adherence to the legal requirements within your
                        jurisdiction.
                      </p>
                    </div>

                    <div>
                      <h6>Disclaimer of Warranties</h6>

                      <p>
                        You understand that we cannot and do not guarantee or
                        warrant that files available for downloading from the
                        internet or the Website will be free of viruses or other
                        destructive code. You are responsible for implementing
                        sufficient procedures and checkpoints to satisfy your
                        particular requirements for anti-virus protection and
                        accuracy of data input and output, and for maintaining a
                        means external to our site for any reconstruction of any
                        lost data. WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE
                        CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK,
                        VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT
                        MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS,
                        DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF
                        THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH
                        THE WEBSITE OR TO YOUR DOWNLOADING OF ANY MATERIAL
                        POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.
                      </p>

                      <p>
                        YOUR USE OF THE WEBSITE, ITS CONTENT AND ANY SERVICES OR
                        ITEMS OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK.
                        THE WEBSITE, ITS CONTENT AND ANY SERVICES OR ITEMS
                        OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN "AS IS"
                        AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY
                        KIND, EITHER EXPRESS OR IMPLIED. NEITHER THE COMPANY NOR
                        ANY PERSON ASSOCIATED WITH THE COMPANY MAKES ANY
                        WARRANTY OR REPRESENTATION WITH RESPECT TO THE
                        COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY,
                        OR AVAILABILITY OF THE WEBSITE. WITHOUT LIMITING THE
                        FOREGOING, NEITHER THE COMPANY NOR ANYONE ASSOCIATED
                        WITH THE COMPANY REPRESENTS OR WARRANTS THAT THE
                        WEBSITE, ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED
                        THROUGH THE WEBSITE WILL BE ACCURATE, RELIABLE,
                        ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE
                        CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT
                        AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
                        COMPONENTS OR THAT THE WEBSITE OR ANY SERVICES OR ITEMS
                        OBTAINED THROUGH THE WEBSITE WILL OTHERWISE MEET YOUR
                        NEEDS OR EXPECTATIONS.
                      </p>

                      <p>
                        THE COMPANY HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND,
                        WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE,
                        INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
                        MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR
                        PARTICULAR PURPOSE.
                      </p>

                      <p>
                        THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH
                        CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
                      </p>
                    </div>

                    <div>
                      <h6>Limitation on Liability</h6>

                      <p>
                        IN NO EVENT WILL THE COMPANY, ITS AFFILIATES OR THEIR
                        LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
                        OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY
                        KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN
                        CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE
                        WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE
                        WEBSITE OR SUCH OTHER WEBSITES OR ANY SERVICES OR ITEMS
                        OBTAINED THROUGH THE WEBSITE OR SUCH OTHER WEBSITES,
                        INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
                        CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT
                        LIMITED TO, PERSONAL INJURY LOSS OF REVENUE, LOSS OF
                        PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS
                        OF USE, LOSS OF GOODWILL, OR LOSS OF DATA, AND WHETHER
                        CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF
                        CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.
                      </p>

                      <p>
                        THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT
                        BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
                      </p>
                    </div>

                    <div>
                      <h6>Indemnification</h6>

                      <p>
                        You agree to defend, indemnify, and hold harmless the
                        Company, its affiliates, licensors, and service
                        providers, and its and their respective officers,
                        directors, employees, contractors, agents, licensors,
                        suppliers, successors, and assigns from and against any
                        claims, liabilities, damages, judgments, awards, losses,
                        costs, expenses, or fees (including reasonable
                        attorneys' fees) arising out of or relating to your
                        violation of these Terms of Use or your use of the
                        Website, including, but not limited to, your User
                        Contributions, any use of the Website's content,
                        services, and products, other than as expressly
                        authorized in these Terms of Use or your use of any
                        information obtained from the Website.
                      </p>
                    </div>

                    <div>
                      <h6>Governing Law and Jurisdiction</h6>

                      <p>
                        All matters relating to the Website and these Terms of
                        Use and any dispute or claim arising therefrom or
                        related thereto (in each case, including non-contractual
                        disputes or claims), shall be governed by and construed
                        in accordance with the internal laws of the State of
                        ________ without giving effect to any choice or conflict
                        of law provision or rule (whether of the State of North
                        Carolina or any other jurisdiction).
                      </p>

                      <p>
                        Any legal suit, action or proceeding arising out of, or
                        related to, these Terms of Use or the Website shall be
                        instituted exclusively in the federal courts of the
                        United States or the courts of the State of __________
                        in each case located in the City of ______ and County of
                        ______, although we retain the right to bring any suit,
                        action or proceeding against you for breach of these
                        Terms of Use in your country of residence or any other
                        relevant country. You waive any and all objections to
                        the exercise of jurisdiction over you by such courts and
                        to venue in such courts.
                      </p>
                    </div>

                    <div>
                      <h6>Limitation on Time to File Claims</h6>

                      <p>
                        ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF
                        OR RELATING TO THESE TERMS OF USE OR THE WEBSITE MUST BE
                        COMMENCED WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION
                        ACCRUES, OTHERWISE, SUCH CAUSE OF ACTION OR CLAIM IS
                        PERMANENTLY BARRED.
                      </p>
                    </div>

                    <div>
                      <h6>Waiver and Severability</h6>

                      <p>
                        No waiver, by the Company of any term or condition set
                        forth in these Terms of Use, shall be deemed a further
                        or continuing waiver of such term or condition or a
                        waiver of any other term or condition, and any failure
                        of the Company to assert a right or provision under
                        these Terms of Use shall not constitute a waiver of such
                        right or provision.
                      </p>

                      <p>
                        If any provision of these Terms of Use is held by a
                        court or other tribunal of competent jurisdiction to be
                        invalid, illegal, or unenforceable for any reason, such
                        provision shall be eliminated or limited to the minimum
                        extent such that the remaining provisions of the Terms
                        of Use will continue in full force and effect.
                      </p>
                    </div>

                    <div>
                      <h6>Entire Agreement</h6>

                      <p>
                        The Terms of Use, our Privacy Policy, SaaS Agreement,
                        and any other documents incorporated herein, constitute
                        the sole and entire agreement between you and the
                        Company with respect to the Website and the Services and
                        supersede all prior and contemporaneous understandings,
                        agreements, representations, and warranties, both
                        written and oral, with respect to the Website and the
                        Services.
                      </p>
                    </div>

                    <div>
                      <h6>Your Comments and Concerns</h6>

                      <p>
                        This website is operated by Verastel, Inc.,
                        _____________.
                      </p>

                      <p>
                        All other feedback, comments, requests for technical
                        support, and other communications relating to the
                        Website should be directed to: ________________.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>{" "}
    </div>
  );
};

export default TermsConditions;
